"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _default = {
  "villar-pellice": {
    "5701e2cb": [{
      "hkey": "786d95b3",
      "slug": "centro",
      "name": "Centro",
      "primary": true,
      "skipSearch": false
    }],
    "basana": [{
      "hkey": "786d95b3",
      "slug": "centro",
      "name": "Centro",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 10,
      "slugLevelParent": "villar-pellice"
    }],
    "710b9925": [{
      "hkey": "786d95b3",
      "slug": "centro",
      "name": "Centro",
      "primary": true,
      "skipSearch": false
    }],
    "bouissa": [{
      "hkey": "786d95b3",
      "slug": "centro",
      "name": "Centro",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 10,
      "slugLevelParent": "villar-pellice"
    }],
    "7a5d02f6": [{
      "hkey": "786d95b3",
      "slug": "centro",
      "name": "Centro",
      "primary": true,
      "skipSearch": false
    }],
    "cavion-villa": [{
      "hkey": "786d95b3",
      "slug": "centro",
      "name": "Centro",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 10,
      "slugLevelParent": "villar-pellice"
    }],
    "268778a3": [{
      "hkey": "1cf799da",
      "slug": "villar-pellice",
      "name": "Villar Pellice",
      "primary": true,
      "skipSearch": false
    }],
    "garnier": [{
      "hkey": "1cf799da",
      "slug": "villar-pellice",
      "name": "Villar Pellice",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 9,
      "slugLevelParent": null
    }],
    "a40ca71a": [{
      "hkey": "6866faaf",
      "slug": "inverso-cognetti-fiemminuto",
      "name": "Inverso Cognetti-Fiemminuto",
      "primary": true,
      "skipSearch": false
    }],
    "inverso-cognetti": [{
      "hkey": "6866faaf",
      "slug": "inverso-cognetti-fiemminuto",
      "name": "Inverso Cognetti-Fiemminuto",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 10,
      "slugLevelParent": "villar-pellice"
    }],
    "cfa41a3b": [{
      "hkey": "6866faaf",
      "slug": "inverso-cognetti-fiemminuto",
      "name": "Inverso Cognetti-Fiemminuto",
      "primary": true,
      "skipSearch": false
    }],
    "inverso-fiemminuto": [{
      "hkey": "6866faaf",
      "slug": "inverso-cognetti-fiemminuto",
      "name": "Inverso Cognetti-Fiemminuto",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 10,
      "slugLevelParent": "villar-pellice"
    }],
    "a1afbc5c": [{
      "hkey": "020774fa",
      "slug": "subiasco-pianta",
      "name": "Subiasco-Piantà",
      "primary": true,
      "skipSearch": false
    }],
    "pianta": [{
      "hkey": "020774fa",
      "slug": "subiasco-pianta",
      "name": "Subiasco-Piantà",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 10,
      "slugLevelParent": "villar-pellice"
    }],
    "d8c408d4": [{
      "hkey": "1cf799da",
      "slug": "villar-pellice",
      "name": "Villar Pellice",
      "primary": true,
      "skipSearch": false
    }],
    "praferrero": [{
      "hkey": "1cf799da",
      "slug": "villar-pellice",
      "name": "Villar Pellice",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 9,
      "slugLevelParent": null
    }],
    "185740b8": [{
      "hkey": "020774fa",
      "slug": "subiasco-pianta",
      "name": "Subiasco-Piantà",
      "primary": true,
      "skipSearch": false
    }],
    "subiasco": [{
      "hkey": "020774fa",
      "slug": "subiasco-pianta",
      "name": "Subiasco-Piantà",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 10,
      "slugLevelParent": "villar-pellice"
    }]
  }
};
exports["default"] = _default;